var ARTICLE_SELECTOR = "main#main-content";

function createLinks( )
{
    const headingConfig     = window.toc_config.headings;
    const selector          = headingConfig.join( ", " );

    const tableOfContents   = document.querySelector( ".js-tab-of-con" );
    const tocHeading        = tableOfContents.querySelector( ".js-tab-of-con-heading" );
    const headings          = Array.from( document.querySelectorAll( ARTICLE_SELECTOR + " :is(" + selector + ")" ) );

    const index             = headings.indexOf( tocHeading );
    const headingsAfter     = headings.slice( index + 1 );

    const liTemplate        = tableOfContents.querySelector( ".js-tab-of-con-link-template" );
    const childListTemplate = tableOfContents.querySelector( ".js-tab-of-con-list-template" );

    while( tableOfContents.querySelector( ".js-tab-of-con-link:not(.js-tab-of-con-link-template)" ) )
    {
        tableOfContents.querySelector( ".js-tab-of-con-link:not(.js-tab-of-con-link-template)" ).remove( );
    }

    while( tableOfContents.querySelector( ".js-tab-of-con-list-template:not(.js-tab-of-con-list-template)" ) )
    {
        tableOfContents.querySelector( ".js-tab-of-con-list-template:not(.js-tab-of-con-list-template)" ).remove( );
    }

    if ( headingsAfter.length > 0 )
    {
        const stack         =
        [
            {
                level: parseInt( headingsAfter[ 0 ].tagName[ 1 ] ),
                ul: tableOfContents,
                li: null 
            }
        ];


        headingsAfter.forEach( ( heading, i ) =>
        {

            if ( !heading.id )
            {
                heading.id = `heading-${ i }`;
            }

            const level = parseInt( heading.tagName[ 1 ] );

            const li = liTemplate.cloneNode( true );
            li.classList.remove( "js-tab-of-con-link-template" );
            const href = li.querySelector( ".js-tab-of-con-link-href" );
            href.href = `#${ heading.id }`;
            href.textContent = heading.textContent;
            href.addEventListener( "click", handleLinkClick );

            while ( level < stack[ stack.length - 1 ].level ) stack.pop( );

            if ( level > stack[ stack.length - 1 ].level )
            {
                const parentLi = stack[ stack.length - 1 ].li;
                const newUl = childListTemplate.cloneNode( true );
                newUl.classList.remove( "js-tab-of-con-list-template" );
                if ( parentLi )
                {
                    parentLi.appendChild( newUl );
                    parentLi.classList.add( "tab-of-con__item--has-children" );
                }
                stack.push( { level, ul: newUl, li: null } );
            }

            const current = stack[ stack.length - 1 ];
            current.ul.appendChild( li );
            current.li = li;
        });
    }
    else
    {
        tableOfContents.style.display = "none";
    }
}

/**
 * 
 * @param { Event } event 
 */
function handleLinkClick( event )
{
    event.preventDefault( );

    const link            = event.target;
    const target          = document.querySelector( link.getAttribute( "href" ) );
    const elementPosition = target.getBoundingClientRect( ).top;
    const tableOfContents = document.querySelector( ".tab-of-con" );
    const scrollBehaviour = tableOfContents.dataset.scrollBehaviour;
    const offset          = tableOfContents.dataset.offset;
    const mobileOffset    = tableOfContents.dataset.mobileOffset;
    const breakpoint      = tableOfContents.dataset.breakpoint;
    var actualOffset      = null;

    if ( window.innerWidth > parseInt( breakpoint ) )
    {
        actualOffset = elementPosition + window.pageYOffset - offset;
    }
    else
    {
        actualOffset = elementPosition + window.pageYOffset - mobileOffset;
    }

    window.scrollTo(
    {
        top: actualOffset,
        behavior: scrollBehaviour
    });

    history.pushState( null, "", link.getAttribute( "href" ) );
    return;
}

function initAccordions( )
{
    const toc = document.querySelector( ".js-tab-of-con" );

    toc.querySelectorAll( ".tab-of-con__item__child-list" ).forEach( list =>
    {
        list.style.height = "0px";
    });

    toc.addEventListener( "click", toggleAccordion );
}

/**
 * @param { Event } event
 */
function toggleAccordion( event )
{
    if ( event.target.matches( ".js-tab-of-con-link .js-tab-of-con-link-href" ) ) return;

    const link = event.target.closest( ".js-tab-of-con-link" );

    if ( !link ) return;

    if ( !link.classList.contains( "tab-of-con__item--has-children" ) ) return;
    if ( link.parentElement !== link.closest( ".js-tab-of-con" ) ) return;

    const childList = link.querySelector( ":scope > .tab-of-con__item__child-list" );
    if ( !childList ) return;

    event.preventDefault( );

    const isExpanded = link.classList.contains( "tab-of-con__item--expanded" );

    if ( isExpanded )
    {
        // Collapse: set explicit height then animate to 0
        childList.style.height = childList.scrollHeight + "px";
        requestAnimationFrame( ( ) =>
        {
            childList.style.height = "0px";
        });
        link.classList.remove( "tab-of-con__item--expanded" );
    }
    else
    {
        // Expand: animate to natural height
        link.classList.add( "tab-of-con__item--expanded" );
        childList.style.height = childList.scrollHeight + "px";

        childList.addEventListener( "transitionend", function onTransitionEnd( )
        {
            childList.style.height = "auto";
            childList.removeEventListener( "transitionend", onTransitionEnd );
        });
    }
}

function initTableOfContents( )
{
    if ( window.toc_config )
    {
        createLinks( );

        if ( window.toc_config.collapsible )
        {
            initAccordions( );
        }
    }
}

window.addEventListener( "DOMContentLoaded", initTableOfContents );

// TOC disappears unless it is rerendered after changes are made to the section in the theme editor
if ( Shopify.designMode )
{
    document.addEventListener( "shopify:section:load", function( )
    {
        setTimeout( initTableOfContents, 100 );
    });
}